import { render, staticRenderFns } from "./HoardingTime.vue?vue&type=template&id=32d7b377&scoped=true&"
import script from "./HoardingTime.vue?vue&type=script&lang=js&"
export * from "./HoardingTime.vue?vue&type=script&lang=js&"
import style0 from "./HoardingTime.vue?vue&type=style&index=0&id=32d7b377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7b377",
  null
  
)

export default component.exports